import { useSelector } from "react-redux";
import { graphql, useLazyLoadQuery } from "react-relay";

import { getOrgUuid } from "state/current_user/selectors";

import type { useOrgNodeIdQuery } from "__generated__/useOrgNodeIdQuery.graphql";

export const organizationIdQuery = graphql`
  query useOrgNodeIdQuery($orgUuid: String!, $skip: Boolean!) {
    organization(uuid: $orgUuid) @skip(if: $skip) {
      id
    }
  }
`;

export const useOrgNodeId = () => {
  const orgUuid = useSelector(getOrgUuid);
  const data = useLazyLoadQuery<useOrgNodeIdQuery>(organizationIdQuery, {
    orgUuid,
    skip: !orgUuid,
  });
  return data?.organization?.id;
};
